import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private auth: AuthenticationService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.includes('DLL')) {
      return next.handle(request);
    }

    const token = this.auth.getToken();
    const reqWithAuth = token
      ? request.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        })
      : request;

    return next.handle(reqWithAuth);
  }
}
